module.exports = __webpack_public_path__ + "static/detecht-env2@2x-834808a3b2b2fe2f5fc899d13361b28e.png";